import { red, orange, blue } from "@material-ui/core/colors"
const styles = ({ palette, mixins, shadows }) => ({
    root: {
        backgroundColor: palette.background.page,
        width: '100%',
        minHeight: 'calc(90vh - 88px)',
        flexGrow: 1,
        padding: '20px',
        marginRight: '20px',
        borderRadius: mixins?.borderRadius,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,

    },
    box: {
        display: 'flex',
        gap: '1rem',
        overflowX: 'hidden',
        boxShadow: shadows[2],
        border: '1px solid',
        borderColor: palette.divider,
        padding: '1rem',
        minHeight: '80vh',
        backgroundColor: palette?.background?.paper,
        borderRadius: mixins?.borderRadius,
        flex: 1,
        width: '100%',

        justifyContent: "start",
        flexDirection: "column",
    },
    row: {
        alignItems: "flex-start",
        display: "flex",
        width: '100%',
    },
    warnings: {
        alignItems: "left",
        textAlign: "left",
    },
    actions: {
        justifyContent: "end",
        backgroundColor: palette.background.paper,
        display: 'flex',
        flex: 1,
        width: '100%',
    },
    action: {
        width: '30px',
    },
    tab: {
        "& .MuiTab-wrapper": {
            color: "red",
        },
    },
    search: {
        width: '100%',
    },
    refresh: {
        textAlign: "right",
    },
    right: {
        alignItems: "center",
        display: "flex",
        textAlign: "right",
    },
    jsonPaper: {
        width: 700,
    },
    limit: {
        margin: '0.5rem',
        width: '6rem'
    },
    tag: {
        margin: '0.5rem',
        width: '10rem'
    },
    text: {
        margin: '0.5rem',
        width: '40rem'
    },
    errorText: {
        color: 'red'
    },
    table: {
        width: '100%',

    },
    errorSign: {
        color: red["A700"],
        width: '20px',
        height: '20px'
    },
    warningSign: {
        color: orange["A700"],
        width: '20px',
        height: '20px'
    },
    infoSign: {
        color: blue["A700"],
        width: '20px',
        height: '20px'
    },
    greenSign: {
        color: 'green',
        width: '20px',
        height: '20px'
    },
    blueSign: {
        marginRight: '0px',
        paddingRight: '0px',
        width: '20px',
        height: '20px'
    },
    warning: {
        color: orange["A700"],
    },
    error: {
        color: red["A700"],
    },
    info: {
        color: blue["A700"],
    },
    green: {
        color: 'green',
    },
    button: {
        margin: '5px'
    }
})

export default styles
